import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferTidalToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferTidalToAppleMusic}
            sections={<PairTransferGuideContent sourceKey="tidal" destKey="appleMusic" />}
        />
    );
}
